import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// TransferChats Redux States
import { GET_TRANSFER_CHAT, TRANSFER_CHAT } from "./actionTypes";
import { loadTransferChats, apiError, transferedChat } from "./actions";

//Include Both Helper File with needed methods
import axios from "axios";

function* getTransferChat({ payload: { id } }) {
  try {
    const response = yield call(
      axios.get,
      `${
        process.env.REACT_APP_MESSAGES_API_URL
      }/tech4h-messages/conversation/transfer?${id ? `id=${id}` : ""}`
    );

    if (response.status === 200) {
      yield put(loadTransferChats(response.data));
    } else {
      throw response.data;
    }
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 400:
          message = "Invalid data";
          break;
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError({ action: "get_transfer_chats", message: message }));
  }
}
function* transferChat({ payload: { data, type, id } }) {
  try {
    let params = {};

    const response = yield call(
      axios.put,
      `${
        process.env.REACT_APP_MESSAGES_API_URL
      }/tech4h-messages/conversation/transfer/${type}?${id ? `id=${id}` : ""}`,
      data,
      {
        params,
      }
    );

    if (response.status === 200) {
      yield put(
        transferedChat({
          status: true,
          chatId: id,
        })
      );
    } else {
      throw response.data;
    }
  } catch (error) {
    let message;
    let body = {};
    if (error?.response?.status) {
      switch (error?.response?.status) {
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          message = error?.response?.data?.message;
          body = error?.response?.data;
          break;
      }
    }
    yield put(apiError({ action: "transfer_chat", message: message, body: body }));
  }
}

export function* watchGetTransferChat() {
  yield takeEvery(GET_TRANSFER_CHAT, getTransferChat);
}
export function* watchTransferChat() {
  yield takeEvery(TRANSFER_CHAT, transferChat);
}
function* authSaga() {
  yield all([fork(watchGetTransferChat)]);
  yield all([fork(watchTransferChat)]);
}

export default authSaga;
